import { ShoppingCart, Package, Loader2 } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { useEffect, useRef } from "react";
import { useAccessories } from "@/hooks/useAccessories";
import { supabase } from "@/integrations/supabase/client";

const formatCurrency = (value: number) =>
  value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const AccessoryGrid = () => {
  const { data: accessories = [], isLoading } = useAccessories();
  const { addItem } = useCart();
  const trackedRef = useRef(false);

  useEffect(() => {
    if (accessories.length > 0 && !trackedRef.current) {
      trackedRef.current = true;
      const rows = accessories.map((p) => ({ product_id: p.id }));
      supabase.from("accessory_views").insert(rows).then(() => {});
    }
  }, [accessories]);

  if (isLoading) {
    return (
      <section id="acessorios" className="py-20 bg-background">
        <div className="container mx-auto px-4 flex justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
      </section>
    );
  }

  if (accessories.length === 0) return null;

  return (
    <section id="acessorios" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gradient-gold mb-4">Acessórios</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Capas, películas, carregadores e mais para proteger seu smartphone
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {accessories.map((item) => (
            <div key={item.id} className="group bg-card rounded-xl border border-border hover:border-primary transition-all duration-300 overflow-hidden hover:shadow-gold hover:-translate-y-1">
              <div className="relative aspect-square overflow-hidden bg-secondary">
                <div className="absolute top-2 right-2 z-10 flex items-center gap-1 bg-secondary/90 backdrop-blur-sm text-foreground text-[10px] font-semibold px-2 py-0.5 rounded-full border border-border">
                  <Package className="w-2.5 h-2.5" />
                  {item.stock}
                </div>
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="p-4">
                <h3 className="font-display text-sm font-semibold text-foreground line-clamp-2">{item.name}</h3>
                {item.color && <p className="text-xs text-muted-foreground mt-0.5">{item.color}</p>}
                <p className="text-lg font-bold text-gradient-gold mt-2">{item.price}</p>
                <p className="text-xs text-primary font-semibold mt-1">
                  Pix: {formatCurrency(item.priceNum * 0.95)} (5% OFF)
                </p>
                <button
                  onClick={() => addItem({ id: item.id, name: item.name, price: item.price, priceNum: item.priceNum, image: item.image })}
                  className="w-full flex items-center justify-center gap-2 bg-gradient-gold text-primary-foreground py-2.5 rounded-lg font-semibold hover:opacity-90 transition-all hover:scale-[1.02] active:scale-[0.98] mt-3 text-sm"
                >
                  <ShoppingCart className="w-3.5 h-3.5" />
                  Comprar
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccessoryGrid;
